import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import * as d3 from "d3";
import { fileUrlToCharge } from "../utils/GetCapacityperProvice";
import * as XLSX from "xlsx";

const styles = (theme) => ({
  card: {
    //margin:10,
    cursor: "pointer",
  },

  cardHeader: {
    fontFamily: "Nunito Sans SemiBold!important",
    fontSize: "16pt",
    backgroundColor: "#069999",
    color: "#fff",
    textAlign: "left",
    height: "100%",
  },
  cardHeaderLink: {
    fontFamily: "Nunito Sans Regular!important",
    fontSize: "12pt",
    backgroundColor: "#069999",
    color: "#fff!important",
    textAlign: "left",
    "&:hover": {
      color: "#bbb!important",
    },
    fontWeight: "400!important",
  },
});

const download = (data, fileName) => {
  const fileExtension = ".xlsx";
  const heading = data.shift();
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet([]);
  XLSX.utils.sheet_add_aoa(ws, heading);
  //Starting in the second row to avoid overriding and skipping headers
  XLSX.utils.sheet_add_json(ws, data, { origin: "A2", skipHeader: true });
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, `${fileName}${fileExtension}`);
};

const mapHeaders = (json) => {
  let headers = [];
  for (let i = 0; i < json.objects.RW_Communes.geometries.length; i++) {
    headers.push({
      label: json.objects.RW_Communes.geometries[i].properties.NAMEFRE,
      key: json.objects.RW_Communes.geometries[i].properties.ADMUKEY,
    });
  }
  return headers;
};

const mapCSV = (json, fileSolarSmall, fileSolarLarge, fileWind, lang) => {
  let headerRow;
  switch (lang) {
    case "de":
      headerRow = [
        [
          "Kommune",
          "Photovoltaik-Leistung (< 10 kVA) [MW]",
          "Photovoltaik-Leistung (> 10 kVA) [MW]",
          "Windkraft [MW]",
        ],
      ];
      break;
    case "en":
      headerRow = [
        [
          "Commune",
          "Photovoltaic power (< 10 kVA) [MW]",
          "Photovoltaic power (> 10 kVA) [MW]",
          "Wind power [MW]",
        ],
      ];
      break;
    default:
    case "fr":
      headerRow = [
        [
          "Commune",
          "Puissance Photovoltaïque (< 10 kVA) [MW]",
          "Puissance Photovoltaïque (> 10 kVA) [MW]",
          "Puissance Eolienne [MW]",
        ],
      ];
  }

  const headers = mapHeaders(json);
  const column1 = maprow1(fileSolarSmall);
  const column2 = maprow1(fileSolarLarge);
  const column3 = maprow1(fileWind);
  const finalRows = [headerRow];
  headers.map((header) => {
    const eleSolar = column1.find((ele) => ele[header.key]);
    const eleSolarLarge = column2.find((ele) => ele[header.key]);
    const eleWind = column3.find((ele) => ele[header.key]);
    const row = [
      header.label,
      eleSolar[Number(header.key)],
      eleSolarLarge[Number(header.key)],
      eleWind[header.key],
    ];
    finalRows.push(row);
  });
  return finalRows;
};

const maprow1 = (file) => {
  let row = [];
  for (let i = 0; i < file.columns.length; i++) {
    const value = file[0][file.columns[i]].replace(".", ",");
    row.push({ [file.columns[i]]: `${value}` });
  }
  return row;
};
function Download(props) {
  const { classes, lang, daySelected, selectedYear, currentMode } = props;
  const files = fileUrlToCharge(daySelected, selectedYear, currentMode);
  const handleDownload = () => {
    let fileName;
    switch (lang) {
      case "de":
        fileName = "Installierte Kapazität pro Gemeinde";
        break;
      case "en":
        fileName = "Installed Capacity per Municipality";
        break;
      default:
      case "fr":
        fileName = "Capacité Installée par Commune";
    }

    Promise.all([
      d3.csv(files.fileSolarLarge),
      d3.csv(files.fileSolarSmall),
      d3.csv(files.fileWind),
      // https://stackoverflow.com/questions/13870265/read-csv-tsv-with-no-header-line-in-d3
      d3.json("/map_data/wallonie_communes.json"),
    ]).then(function (d, error) {
      if (error) {
        console.log(error);
      } else {
        //format demand
        const result = mapCSV(d[3], d[1],d[0], d[2], lang);
        download(result, fileName);
      }
    });
  };

  let title;

  switch (lang) {
    case "de":
      title = "Daten zur installierten Kapazität nach Gemeinde herunterladen";
      break;
    case "en":
      title = "Download installed capacity data per municipality";
      break;
    default:
    case "fr":
      title = "Télécharger les données de la capacité installée par commune";
  }

  return (
    <Card className={classes.card} onClick={handleDownload}>
      <CardHeader
        className={classes.cardHeader}
        disableTypography
        title={title}
      />
    </Card>
  );
}

Download.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Download);
